import { type ISupporterChatRoomQuery } from 'application/querySchemas/ISupporterChatRoomQuery';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import {
    type ISupporterChatRoomListClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ISupporterChatRoomListClient';
import {
    type ISupporterChatMessagesClient,
    IGetResponse as ISupporterChatMessagesResponse,
} from 'interfaceAdapter/gatewaySchemas/ISupporterChatMessagesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class SupporterChatRoomQuery implements ISupporterChatRoomQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ISupporterChatRoomListClient')
        public readonly supporterChatRoomListClient: ISupporterChatRoomListClient,
        @inject('ISupporterChatMessagesClient')
        public readonly supporterChatMessagesClient: ISupporterChatMessagesClient,
    ) {}

    public async fetchRoomList(companyName?: string): Promise<IGetResponse['data']> {
        const { data, message } = await this.supporterChatRoomListClient.get({
            token: this.supportUserToken.get() || '',
            companyName,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchMessages(chatRoomId: number): Promise<ISupporterChatMessagesResponse['data']> {
        const { data, message } = await this.supporterChatMessagesClient.get({
            token: this.supportUserToken.get() || '',
            chatRoomId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
